import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import {
  Orders,
  Order,
  CreateOrder,
  UpdateOrder,
  OrderFormDocument,
} from "./pages";

export const OrdersRouter = [
  <Route
    path="/orders"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Orders />
      </ProtectedRoute>
    }
  />,

  <Route path="/order">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateOrder />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Order />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateOrder />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/bon-de-commande"
      element={
        <ProtectedRoute roles={["Any"]}>
          <OrderFormDocument />
        </ProtectedRoute>
      }
    />
  </Route>,
];
